import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDoor = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		stroke: "currentColor",
		clipRule: "evenodd",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeMiterlimit: 1.5
	},
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5.919,21.474l0,-14.477c0,-1.678 1.362,-3.041 3.041,-3.041l6.081,0c1.678,0 3.041,1.362 3.041,3.041l0,14.477",
			style: {
				fill: "none",
				stroke: "currentColor",
				strokeWidth: "1.5px"
			}
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.522,21.474l18.911,0",
			style: {
				fill: "none",
				stroke: "currentColor",
				strokeWidth: "1.5px"
			}
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8.69,
			cy: 12.719,
			r: .719
		})
	]
});
export default SvgDoor;
